module.exports = __webpack_public_path__ + "static/media/process-bg.ffab5769.png";